import React from "react"

import { useTranslation } from "@bounce/i18n"

import type { CityScreenProps } from "../CityScreen"
import type { Interpolations } from "../hooks/useInterpolations"
import { HowItWorksCompact } from "@/components/LuggageStorage/HowItWorks/HowItWorksCompact/HowItWorksCompact"
import { StoreGridSection } from "@/components/LuggageStorage/StoreSlider/StoreGridSection"
import { useStepsCompact } from "@/screens/LuggageStorage/CityScreen/hooks/useStepsCompact"

type MainContentProps = Pick<CityScreenProps, "city" | "mainCityStores"> & {
  interpolations: Interpolations
  absolutePath: string
}

export const MainContent = ({ absolutePath, city, interpolations, mainCityStores }: MainContentProps) => {
  const { t } = useTranslation("marketing-ls-city")
  const stepsCompact = useStepsCompact({ interpolations })

  return (
    <>
      {mainCityStores.length > 0 && (
        <StoreGridSection
          stores={mainCityStores}
          from="City"
          path={absolutePath}
          searchQuery={city.query}
          title={t(
            "screen.cityScreen.nearestCityStoresSlider.titleV2",
            "Top-rated storage locations in {CITY_NAME}",
            interpolations,
          )}
          className="pt-section"
          sectionViewedMeta={{ section: "CityNearestStores" }}
          renderStructuredData
        />
      )}
      <HowItWorksCompact
        steps={stepsCompact}
        title={t(
          "screen.cityScreen.howItWorks.titleOptimized",
          "How to store your luggage in {{CITY_NAME}}",
          interpolations,
        )}
        className="py-section"
      />
    </>
  )
}
